import request from '@/utils/request';

//查询当前机构点券余额
export function getorgbalance(params) {
  return request('/org_api/v1/orgfinance/getorgbalance', {
    method: 'get',
    params: { ...params }
  })
}
//查询当前机构点券流水
export function queryfinance(params) {
  return request('/org_api/v1/orgfinance/queryfinance', {
    method: 'get',
    params: { ...params }
  })
}

//查询机构用户列表
export function orguserlist(params) {
  return request('/org_api/v1/orgfinance/orguserlist', {
    method: 'get',
    params: { ...params }
  })
}
export function getQueryaccount(params={}){
  return request('/org_api/v1/account/queryaccount', {
    method: 'get',
    params: { ...params }
  })
}
export function createdAddaccount(data={}){
  return request('/org_api/v1/account/addaccount', {
    method: 'post',
    data: { ...data }
  })
}
export function updateAccount(data={}){
  return request('/org_api/v1/account/updateaccount', {
    method: 'post',
    data: { ...data }
  })
}
export function getaccounttotal(params={}){
  return request('/org_api/v1/account/getaccounttotal', {
    method: 'get',
    params: { ...params }
  })
}
export function addsupplier(data={}){
  return request('/org_api/v1/account/addsupplier', {
    method: 'post',
    data: { ...data }
  })
}
export function querysupplier(data={}){
  return request('/org_api/v1/account/querysupplier', {
    method: 'get',
    params: { ...data }
  })
}
export function deletesupplier(data={}){
  return request('/org_api/v1/account/deletesupplier', {
    method: 'delete',
    params: { ...data }
  })
}
export function updatesupplier(data={}){
  return request('/org_api/v1/account/updatesupplier', {
    method: 'post',
    data: { ...data }
  })
}
export function cancelorderretransactionrecord(data={}){
  return request('/org_api/v1/account/cancelorderretransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function batchaddretransactionrecord(data={}){
  return request('/org_api/v1/account/batchaddretransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function accountQueryfinance(params={}){
  return request('/org_api/v1/account/queryfinance', {
    method: 'get',
    params: { ...params }
  })
}
export function supplierlist(data={}){
  return request('/org_api/v1/account/supplierlist', {
    method: 'get',
    params: { ...data }
  })
}
export function querycorecustomers(params={}){
  return request('/org_api/v1/account/querycorecustomers', {
    method: 'get',
    params: { ...params }
  })
}
export function accountposting(data={}){
  return request('/org_api/v1/account/accountposting', {
    method: 'post',
    data: { ...data }
  })
}
export function accountbilling(data={}){
  return request('/org_api/v1/account/accountbilling', {
    method: 'post',
    data: { ...data }
  })
}
export function addcorecustomers(data={}){
  return request('/org_api/v1/account/addcorecustomers', {
    method: 'post',
    data: { ...data }
  })
}
export function deletecorecustomers(data={}){
  return request('/org_api/v1/account/deletecorecustomers', {
    method: 'delete',
    params: { ...data }
  })
}
export function updatecorecustomers(data={}){
  return request('/org_api/v1/account/updatecorecustomers', {
    method: 'post',
    data: { ...data }
  })
}
export function queryrechargevisaorder(params={}){
  return request('/org_api/v1/orgfinance/queryrechargevisaorder', {
    method: 'get',
    params: { ...params }
  })
}
export function queryorderretransactionrecord(params={}){
  return request('/org_api/v1/account/queryorderretransactionrecord', {
    method: 'get',
    params: { ...params }
  })
}
export function queryorderpay(params={}){
  return request('/org_api/v1/account/queryorderpay', {
    method: 'get',
    params: { ...params }
  })
}
export function queryretransactionrecord(params={}){
  return request('/org_api/v1/account/queryretransactionrecord', {
    method: 'get',
    params: { ...params }
  })
}
export function queryextransactionrecord(params={}){
  return request('/org_api/v1/account/queryextransactionrecord', {
    method: 'get',
    params: { ...params }
  })
}
export function queryorderbill(params={}){
  return request('/org_api/v1/orgfinance/queryorderbill', {
    method: 'post',
    data: { ...params }
  })
}
export function addretransactionrecord(data={}){
  return request('/org_api/v1/account/addretransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function batchauditre(data={}){
  return request('/org_api/v1/account/batchauditre', {
    method: 'post',
    data: { ...data }
  })
}
export function addorderretransactionrecord(data={}){
  return request('/org_api/v1/account/addorderretransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function audiextransactionrecord(data={}){
  return request('/org_api/v1/account/audiextransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function addextransactionrecord(data={}){
  return request('/org_api/v1/account/addextransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function delaccount(params={}){
  return request('/org_api/v1/account/delaccount', {
    method: 'get',
    params: { ...params }
  })
}
export function audiretransactionrecord(data={}){
  return request('/org_api/v1/account/audiretransactionrecord', {
    method: 'post',
    data: { ...data }
  })
}
export function accountlist(params={}){
  return request('/org_api/v1/account/accountlist', {
    method: 'get',
    params: { ...params }
  })
}
//查询机构流水分类类型
export function orgfinancetypeselect(params) {
  return request('/org_api/v1/orgfinance/orgfinancetypeselect', {
    method: 'get',
    params: { ...params }
  })
}

//查询当前机构点券历史收入支出数据
export function getorgtotaldata(params) {
  return request('/org_api/v1/orgfinance/getorgtotaldata', {
    method: 'get',
    params: { ...params }
  })
}

// 查询当前机构快付账户流水*
export function getorgfastpay(params) {
  return request('/org_api/v1/orgfinance/queryvisafinance', {
    method: 'get',
    params: { ...params }
  })
}

// 查询当前机构快付账户余额*
export function getorgfastpaybalance(params) {
  return request('/org_api/v1/orgfinance/getorgvisabalance', {
    method: 'get',
    params: { ...params }
  })
}

// 查询当前机构快付账户历史收入支出数据*
export function getorgfastpaytotaldata(params) {
  return request('/org_api/v1/orgfinance/getorgvisatotaldata', {
    method: 'get',
    params: { ...params }
  })
}
export function kmpayvisafee(params) {
  return request('/org_api/v1/orgfinance/kmpayvisafee', {
    method: 'post',
    data: { ...params }
  })
}
// 快付账户充值
export function orgfastpayrecharge(params) {
  return request('/org_api/v1/orgfinance/createrechargevisaorder', {
    method: 'post',
    data: { ...params }
  })
}
// 查询快付账户收款账户
export function getorgvisabankcard(params) {
  return request('/org_api/v1/orgfinance/getorgvisabankcard', {
    method: 'get',
    params: { ...params }
  })
}

// 快付账户在线支付
export function orgfastpayonlinepay(params) {
  return request('/org_api/v1/orgfinance/visaonlinepay', {
    method: 'post',
    data: { ...params }
  })
}